// You can write more code here

/* START OF COMPILED CODE */

import PreloadImage from "../components/core/PreloadImage";
/* START-USER-IMPORTS */
import { PreloadScene } from '@scarybeasties/phaser-framework-core/scenes';
import { assetsToLoad } from '../assets-to-load';
import { TransitionPoint } from '../app-routing';
/* END-USER-IMPORTS */

export default class PreloadGeneric extends PreloadScene {

  constructor() {
    super("PreloadGeneric");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.rectangle(960, 384, 1920, 768);
    bg.isFilled = true;
    bg.fillColor = 374937;

    // outline
    const outline = this.add.image(955, 570, "preloader-generic", "loading-bar-bg.png");

    // preloaderBg
    const preloaderBg = this.add.image(960, 364, "preloader-generic", "loading-bar-fill.png");
    preloaderBg.visible = false;

    // preloadBar
    const preloadBar = this.add.image(960, 563, "preloader-generic", "loading-bar-fill.png");

    // image_1
    this.add.image(960, 268, "preloader-generic", "logo-looneytunes.png");

    // preloadBar (components)
    const preloadBarPreloadImage = new PreloadImage(preloadBar);
    preloadBarPreloadImage.reverseDirection = true;

    this.outline = outline;
    this.preloaderBg = preloaderBg;
    this.preloadBar = preloadBar;

    this.events.emit("scene-awake");
  }

  private outline!: Phaser.GameObjects.Image;
  private preloaderBg!: Phaser.GameObjects.Image;
  private preloadBar!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  // Write your code here

  public preload() {
    this.editorCreate();

    super.preload();

    assetsToLoad(this);

    this.load.on(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();
  }

  public create() {
    super.create();
  }


  protected finish() {
    super.finish();

    this.app.App.gotoNextScene(this, TransitionPoint.PreloadEnd, { test: 'test' });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
